import { BaseModel } from '../classes/base-model';

export class AttributeType extends BaseModel{
	IsActive: boolean;
    Id: number;
    Name: string;
}



// WEBPACK FOOTER //
// ./src/app/models/attribute-type.ts